import { useState } from 'react';
import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  const handleImgError = (idx: number) => {
    setImgErrors((prev) => ({ ...prev, [idx]: true }));
  };

  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            热门视频
          </h2>
          <p className="text-sm text-foreground-500">全网最劲爆的娱乐视频，第一时间为你呈现</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
              <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                {!imgErrors[i] ? (
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleImgError(i)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-image-line text-4xl text-background-400"></i>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center bg-white/90 rounded-full">
                  <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}